import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
//import { APP_DEFAULT_PATH } from 'config';
import LcdwUseAuth from 'hooks/useLcdwAuth';

// ==============================|| GUEST GUARD ||============================== //

const LcdwGuard = ({ children }) => {
  const { isLoggedIn } = LcdwUseAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(location?.state?.from ? location?.state?.from : 'lcdw/dashboard', {
        state: {
          from: ''
        },
        replace: true
      });
      window.location.reload();
    }
  }, [isLoggedIn, navigate, location]);

  return children;
};

LcdwGuard.propTypes = {
  children: PropTypes.node
};

export default LcdwGuard;
